module.exports = __webpack_public_path__ + "static/media/dashboard-call.edc880c7.svg";